import KoioteValueLabelWrite from "./KoioteValueLabelWrite.vue";
import KoioteValueLabelWriteProperties from "./KoioteValueLabelWriteProperties.vue";
import KoioteValueLabelWriteProperty from "./default.json";

export default {
  install(Vue) {
    Vue.component(KoioteValueLabelWrite.name, KoioteValueLabelWrite);
    Vue.component(KoioteValueLabelWriteProperties.name, KoioteValueLabelWriteProperties);
    Vue.prototype.$ValueLabelWriteProperties = KoioteValueLabelWriteProperty;
  },
};
